import React from 'react';
const GroupUI = () => {
    return (
        <div>

        </div>
    )
}

export default GroupUI;